module.exports = __webpack_public_path__ + "img/Wessels-skrifter_Detalj-fra-En-aften-i-Det-norske-selskap.6cf1a9dd.jpg";